import myAPI from './resources'
import config from '../config'

export default {
  getModels: function (data) {
    return myAPI.get(`https://vpic.nhtsa.dot.gov/api/vehicles/GetModelsForMakeIdYear/makeId/${data.make}/modelyear/${data.year}?format=json`)
      .then(function (response) {
        return response
      })
  },
  checkVIN: function (data) {
  	 return myAPI.get(config.inventory_root + `/tblVinDecoded/${data.vin}`)
      .then(function (response) {
        console.log(response);
        return response
      })
  },
  checkVINGeneral: function (data) {
     return myAPI.get(config.inventory_root + `/tblVinDecoded/${data.vin}`)
      .then(function (response) {
        console.log(response);
        return response
      })
  },
  getActiveComponentTypes: async function() {
    return await myAPI.get(config.carbuyservice + '/ComponentType/Active');
  },
  getSpecificComponentTypes: async function(componentTypeID) {
    return await myAPI.get(config.carbuyservice + `/ComponentType/${componentTypeID}`);
  }
}



// WEBPACK FOOTER //
// ./src/api/vehicle.js